import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Spinner, Modal, Button } from "react-bootstrap";
import { FaInstagram } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const INSTAGRAM_ACCESS_TOKEN = "IGAATe62DtF5lBZAGJvU1lLYzFtT3RTbXBHMVhabV85bTUxdFZA1SG53eTFZAT3gyaXRjM2hQc3RvYXZAid29kV09zSTUxaFNINTVvTlFpd3ZAKenB0eWg0WU1rcnlFeU5BVzhLU2huOHQtT1cteXA0VWt5eHBsQnJ3WC1HcGpTU0hnTQZDZD";
const INSTAGRAM_GRADIENT = "linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)";
const INSTAGRAM_GRADIENT_OVERLAY = "linear-gradient(45deg, rgba(240, 148, 51, 0.92) 0%, rgba(230, 104, 60, 0.92) 25%, rgba(220, 39, 67, 0.92) 50%, rgba(204, 35, 102, 0.92) 75%, rgba(188, 24, 136, 0.92) 100%)";

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [isMobileOrTab, setIsMobileOrTab] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTab(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await fetch(
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${INSTAGRAM_ACCESS_TOKEN}&limit=8`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch Instagram posts");
        }
        const data = await response.json();
        setPosts(data.data || []);
      } catch (err) {
        console.error("Instagram API Error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInstagramPosts();
  }, []);

  if (loading) {
    return (
      <Container className="text-center py-5">
        <Spinner animation="border" variant="danger" style={{ color: "#dc2743" }} />
      </Container>
    );
  }

  if (error || posts.length === 0) {
    return null; // Fail silently or do not render if token expires/has no data
  }

  // Helper to format ISO Date
  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const handlePostClick = (post, e) => {
    e.preventDefault();
    setSelectedPost(post);
    setShowModal(true);
  };

  return (
    <div style={{ background: "#fdfdfd", padding: "80px 0" }} className="instagram-section border-top">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-5 flex-wrap">
          <div>
            <h6 className="text-muted text-uppercase mb-2 fw-semibold" style={{ letterSpacing: "2px", fontSize: "11px" }}>
              Social Stream
            </h6> 
            <h2 className="fw-bold mb-0" style={{ color: "#262626" }}>
              Latest From Our{" "}
              <span 
                style={{ 
                  background: INSTAGRAM_GRADIENT,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "bold"
                }}
              >
                Instagram
              </span>
            </h2>
          </div>
          <a
            href="https://www.instagram.com/ideal_corporate_services"
            target="_blank"
            rel="noopener noreferrer"
            className="btn text-white rounded-pill px-4 py-2 mt-3 mt-md-0 d-flex align-items-center gap-2 fw-semibold"
            style={{
              background: INSTAGRAM_GRADIENT,
              border: "none",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(225, 48, 108, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <FaInstagram size={18} /> Follow @idealcorporateservices
          </a>
        </div>

        {isMobileOrTab ? (
          <Swiper
            modules={[Autoplay]}
            spaceBetween={16}
            slidesPerView={1.3}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              576: {
                slidesPerView: 2.3,
              },
              768: {
                slidesPerView: 3,
              },
            }}
            className="mySwiper py-3"
          >
            {posts.map((post) => {
              const isVideo = post.media_type === "VIDEO";
              const imageUrl = isVideo ? (post.thumbnail_url || post.media_url) : post.media_url;

              return (
                <SwiperSlide key={post.id}>
                  <div
                    onClick={(e) => handlePostClick(post, e)}
                    style={{ cursor: "pointer" }}
                  >
                    <Card
                      className="border-0 rounded-4 overflow-hidden shadow-sm position-relative instagram-card"
                      style={{
                        aspectRatio: "1/1",
                        transition: "transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1), box-shadow 0.4s ease",
                      }}
                    >
                      <Card.Img
                        src={imageUrl}
                        alt="Instagram Post"
                        className="w-100 h-100 object-fit-cover"
                        style={{ transition: "transform 0.6s ease" }}
                      />
                      
                      {/* Hover Overlay */}
                      <div
                        className="instagram-overlay d-flex flex-column justify-content-between p-3"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: INSTAGRAM_GRADIENT_OVERLAY,
                          opacity: 0,
                          transition: "opacity 0.3s ease-in-out",
                          color: "#fff",
                          zIndex: 2,
                        }}
                      >
                        <div className="text-end">
                          <FaInstagram size={22} color="#fff" />
                        </div>
                        
                        <div>
                          <p
                            className="mb-2 text-justify"
                            style={{
                              fontSize: "13px",
                              display: "-webkit-box",
                              WebkitLineClamp: 4,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: "1.45",
                              fontWeight: "500"
                            }}
                          >
                            {post.caption || "View on Instagram"}
                          </p>
                          <small className="opacity-75" style={{ fontSize: "11px" }}>
                            {formatDate(post.timestamp)}
                          </small>
                        </div>
                      </div>
                    </Card>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <Row className="g-4">
            {posts.map((post) => {
              const isVideo = post.media_type === "VIDEO";
              const imageUrl = isVideo ? (post.thumbnail_url || post.media_url) : post.media_url;

              return (
                <Col key={post.id} xs={12} sm={6} md={4} lg={3}>
                  <div
                    onClick={(e) => handlePostClick(post, e)}
                    style={{ cursor: "pointer" }}
                  >
                    <Card
                      className="border-0 rounded-4 overflow-hidden shadow-sm position-relative instagram-card"
                      style={{
                        aspectRatio: "1/1",
                        transition: "transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1), box-shadow 0.4s ease",
                      }}
                    >
                      <Card.Img
                        src={imageUrl}
                        alt="Instagram Post"
                        className="w-100 h-100 object-fit-cover"
                        style={{ transition: "transform 0.6s ease" }}
                      />
                      
                      {/* Hover Overlay */}
                      <div
                        className="instagram-overlay d-flex flex-column justify-content-between p-3"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          background: INSTAGRAM_GRADIENT_OVERLAY,
                          opacity: 0,
                          transition: "opacity 0.3s ease-in-out",
                          color: "#fff",
                          zIndex: 2,
                        }}
                      >
                        <div className="text-end">
                          <FaInstagram size={22} color="#fff" />
                        </div>
                        
                        <div>
                          <p
                            className="mb-2 text-justify"
                            style={{
                              fontSize: "13px",
                              display: "-webkit-box",
                              WebkitLineClamp: 4,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              lineHeight: "1.45",
                              fontWeight: "500"
                            }}
                          >
                            {post.caption || "View on Instagram"}
                          </p>
                          <small className="opacity-75" style={{ fontSize: "11px" }}>
                            {formatDate(post.timestamp)}
                          </small>
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </Container>

      {/* Post Details Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
      >
        <Modal.Body className="p-0">
          <Row className="g-0">
            {/* Media Column */}
            <Col md={6} style={{ backgroundColor: "#050505", display: "flex align-items-center justify-content-center", aspectRatio: "1/1" }}>
              {selectedPost && (
                <img
                  src={selectedPost.media_type === "VIDEO" ? (selectedPost.thumbnail_url || selectedPost.media_url) : selectedPost.media_url}
                  alt="Instagram Post"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              )}
            </Col>
            
            {/* Content Column */}
            <Col md={6} className="d-flex flex-column justify-content-between p-4" style={{ backgroundColor: "#ffffff" }}>
              <div>
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: INSTAGRAM_GRADIENT,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      marginRight: "12px",
                      flexShrink: 0
                    }}
                  >
                    <FaInstagram size={18} />
                  </div>
                  <div>
                    <h6 className="mb-0 fw-bold" style={{ color: "#262626", fontSize: "14px" }}>idealcorporateservices</h6>
                    <small className="text-muted" style={{ fontSize: "11px" }}>Instagram Feed Post</small>
                  </div>
                </div>
                
                <hr className="my-2" style={{ opacity: 0.1 }} />
                
                <div 
                  style={{ maxHeight: "260px", overflowY: "auto", paddingRight: "5px" }} 
                  className="instagram-caption-scroll"
                >
                  <p 
                    style={{ 
                      fontSize: "13.5px", 
                      color: "#262626", 
                      whiteSpace: "pre-line", 
                      lineHeight: "1.5" 
                    }} 
                    className="text-justify mb-0"
                  >
                    {selectedPost?.caption || "View post on Instagram"}
                  </p>
                </div>
              </div>

              <div>
                <hr className="my-2" style={{ opacity: 0.1 }} />
                <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
                  <small className="text-muted" style={{ fontSize: "11px" }}>
                    Posted on {selectedPost && formatDate(selectedPost.timestamp)}
                  </small>
                  <div className="d-flex gap-2">
                    <a
                      href={selectedPost?.permalink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn text-white rounded-pill px-3 py-2 fw-semibold d-flex align-items-center gap-1"
                      style={{
                        background: INSTAGRAM_GRADIENT,
                        fontSize: "12px",
                        border: "none",
                        transition: "transform 0.2s ease, opacity 0.2s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.opacity = "0.95";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.opacity = "1";
                      }}
                    >
                      Open Link <FaInstagram />
                    </a>
                    <Button
                      variant="light"
                      onClick={() => setShowModal(false)}
                      className="rounded-pill px-3 py-2 fw-semibold"
                      style={{ fontSize: "12px", border: "1px solid #ddd" }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default InstagramFeed;
